export default {
  getAutocompleteArticles: (state) => state.autocompleteArticles,
  getArticles: (state) => state.articles,
  getArticle: (state) => (id) => {
    return state.articles.find(article => article.id === parseInt(id))
  },
  getEmptyArticle: (state) => JSON.parse(JSON.stringify(state.emptyArticle)),
}